<template>
  <div class="notexist pop_white-s pop_bege popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="closePop"> <close /></a>
        </div>
        <div class="corner-top"></div>
        <div class="exists_icon"><LOGO /></div>
        <div class="pop_frame">
          <h2 class="title25">
            המוצרים האלה חסרים היום במלאי<span>ולא הועתקו להזמנה:</span>
          </h2>
          <div class="text">
            <div
              v-for="product in this.$store.state.outOfStockCart"
              :key="product.id" v-html="product.name"
            >
              
            </div>
          </div>
          <div class="bt_green ease">
            <a href="#" @click.prevent="closePop">אישור</a>
          </div>
        </div>
      </div>
    </div>
    <div class="bgblack"></div>
  </div>
</template>

<script>
import close from "../../assets/img/close.svg";
import LOGO from "../../assets/img/carmella.svg";
export default {
  data() {
    return {};
  },
  methods: {
    closePop() {
      this.$modal.hide("not-exist");
    }
  },
  components: {
    LOGO,
    close
  }
};
</script>

<style scoped></style>
